// components/WorkInProgressGate.jsx
import React from 'react';
import { useWorkInProgress } from '../context/WorkInProgressContext';
import WorkInProgress from './WorkInProgress';

const WorkInProgressGate = ({ children }) => {
    const { isWorkInProgress } = useWorkInProgress();

    if (isWorkInProgress) {
        return <WorkInProgress />;
    }

    return <>{children}</>;
};

export default WorkInProgressGate;